import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { isClientPreview } from './client-session';

const FILES_PATH = '/api/files/';
const MARKER = 'as=student';

function markUrl(value: string): string {
  if (!value.includes(FILES_PATH) || value.includes(MARKER)) return value;
  return `${value}${value.includes('?') ? '&' : '?'}${MARKER}`;
}

function stripUrl(value: string): string {
  if (!value.includes(FILES_PATH) || !value.includes(MARKER)) return value;
  return value.replace(/\?as=student&/g, '?').replace(/[?&]as=student(?=&|#|$)/g, '');
}

// Метка идёт на любую строку с /api/files/: не-фото (шрифты, декор) её игнорируют, меняется лишь ключ кеша.
function walkStrings(body: unknown, apply: (value: string) => string): unknown {
  if (typeof body === 'string') return apply(body);
  if (Array.isArray(body)) return body.map(item => walkStrings(item, apply));
  if (body && typeof body === 'object') {
    return Object.fromEntries(Object.entries(body).map(([key, value]) => [key, walkStrings(value, apply)]));
  }

  return body;
}

// Тело запроса = обычный JSON-объект: FormData, Blob и строки уходят на бэк нетронутыми.
function isJsonBody(body: unknown): boolean {
  return Array.isArray(body) || (!!body && typeof body === 'object' && Object.getPrototypeOf(body) === Object.prototype);
}

// Запрос = сохранение: метка не должна осесть в модели ученика и увести всех зрителей на ученический этаж.
// Отдельно экспортирована для запросов мимо HttpClient (keepalive-сохранение редактора).
// Без проверки предпросмотра: keepalive уходит на pagehide, когда записи уже может не быть,
// а законно сохранённое тело метку не несёт никогда.
export function stripClientPreviewMarker(body: unknown): unknown {
  return walkStrings(body, stripUrl);
}

export const clientPreviewFilesInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isClientPreview()) return next(req);
  // Ответ = показ (метку ставим), запрос = сохранение (метку снимаем).
  const outgoing = isJsonBody(req.body) ? req.clone({ body: stripClientPreviewMarker(req.body) }) : req;
  if (req.responseType !== 'json') return next(outgoing);
  return next(outgoing).pipe(
    map(event => (event instanceof HttpResponse ? event.clone({ body: walkStrings(event.body, markUrl) }) : event)),
  );
};
